import {
  getDocumentationChildren,
  getDocumentationModel,
  searchDocumentations,
} from 'serviceWorker/broadcasts/documentations';
import { getFilteredDirectory } from 'serviceWorker/broadcasts/documentationsFilteredDirectory';
import { documentationSaver } from 'serviceWorker/services/documentations/addDocumentation';
import { documentationModuleReads } from 'serviceWorker/services/documentationModule';
import {
  documentationsSync,
  getDocumentationSignedUrls,
  handleDeleteDocumentations,
  handleEditDocumentation,
  handleEditDocumentationVersion,
  handleMoveDocumentation,
  handleRestoreDocumentations,
} from 'serviceWorker/services/documentations';
import { calculateDocumentationOperationPreflight } from 'serviceWorker/services/documentations/preflightDocumentationOperation';
import { channelServer, ChannelUnsubscribe } from 'shared/channels';
import { documentationContract } from 'shared/domain/documentation/documentationContract';
import { shouldResyncAfterSearch } from 'shared/domain/documentation/searchedDocumentationsRequest';
import { createUniqueId } from 'shared/utils/id/id';
import { runWhenRequestsAllowed } from './runWhenRequestsAllowed';
import { syncWithPermissions } from './serveEntityRequests';

/** Answers documentation requests of the page. */
export function serveDocumentationRequests(): ChannelUnsubscribe {
  return channelServer.handle(documentationContract, {
    getOneById: ({ id }) => getDocumentationModel(id),
    getChildren: ({ parentId }) => documentationModuleReads.documentations(() => getDocumentationChildren(parentId)),
    getFilteredDirectory: (request) =>
      documentationModuleReads.directoryContent(() => getFilteredDirectory(request)),
    search: (request) =>
      documentationModuleReads.documentations(() => searchDocumentations(request.searchPhrase), {
        refresh: shouldResyncAfterSearch(request),
      }),
    preflight: calculateDocumentationOperationPreflight,
    create: ({ documentation, uniqueId = createUniqueId() }) =>
      documentationSaver.execute(documentation, uniqueId),
    edit: handleEditDocumentation,
    editVersion: handleEditDocumentationVersion,
    remove: ({ documentations, directories, signature }) =>
      handleDeleteDocumentations({ documentations, directories, signature }),
    restore: ({ documentations, directories = [], signature }) =>
      handleRestoreDocumentations({ documentations, directories, signature }),
    setParent: ({ parentId, documentations, directories }) =>
      handleMoveDocumentation({ parentId, documentations, directories }),
    sync: () => runWhenRequestsAllowed(() => syncWithPermissions(documentationsSync.sync)),
    getSignedUrl: ({ documentationId, versionId, token }) =>
      getDocumentationSignedUrls({ documentationId, versionId, token: token ?? '' }),
  });
}
